var _desc, _defs, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _rect4, _rect5, _ellipse, _polygon, _polygon2, _polygon3, _ellipse2, _path, _polyline, _rect6, _polygon4, _polygon5, _path2, _polygon6, _polygon7, _ellipse3, _path3, _rect7, _path4, _rect8, _path5, _ellipse4, _polygon8, _polygon9, _rect9, _rect10, _rect11, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _rect12, _rect13, _ellipse5, _polygon10, _polygon11, _polygon12, _ellipse6, _path6, _polyline2, _rect14, _polygon13, _polygon14, _path7, _polygon15, _polygon16, _ellipse7, _path8, _rect15, _path9, _rect16, _path10, _ellipse8, _polygon17, _polygon18, _rect17, _rect18, _rect19, _path11, _rect20, _rect21, _path12, _polygon19, _path13, _polygon20, _path14, _polygon21, _polygon22, _path15, _polygon23, _path16, _polygon24, _polygon25, _path17, _polygon26, _path18, _polygon27, _g, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _path19, _rect22, _path20, _rect23, _path21, _path22, _polyline3, _rect24, _polygon34, _polygon35, _path23, _path24, _polyline4, _rect25, _polygon36, _polygon37, _path25, _g2, _g3, _path26, _path27, _path28, _path29, _path30, _path31, _g4, _g5, _g6, _g7, _g8, _path32, _path33, _path34, _g9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1656px",
    height: "1328px",
    viewBox: "0 0 1656 1328",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-login") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9617108%",
    y1: "0.872274143%",
    x2: "50.9377106%",
    y2: "126.82866%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4%",
    y1: "49.9941294%",
    x2: "100%",
    y2: "49.9941294%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9619581%",
    y1: "0.86100861%",
    x2: "50.9399138%",
    y2: "126.829643%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9610799%",
    y1: "0.86100861%",
    x2: "50.9396432%",
    y2: "126.829643%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.704797%",
    y2: "50%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C89A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC194",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776F56",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373428",
    offset: "68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100F0C",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illustration-login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOG-IN-01"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0.4,
    y: 0.9,
    width: 1655.19,
    height: 1327.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(312.000000, 147.000000)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#122737",
    fillRule: "nonzero",
    transform: "translate(254.370000, 144.200000) rotate(90.000000) translate(-254.370000, -144.200000) ",
    x: 111.06,
    y: -110.03,
    width: 286.62,
    height: 508.46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 8.13,
    y: 8.87,
    width: 492.49,
    height: 270.65
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 48.93,
    x2: 213.65,
    y2: 48.93,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 74.06,
    x2: 233.07,
    y2: 74.06,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 84.46,
    x2: 233.07,
    y2: 84.46,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 94.85,
    x2: 233.07,
    y2: 94.85,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 106.1,
    x2: 233.07,
    y2: 106.1,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 176,
    x2: 213.65,
    y2: 176,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 201.14,
    x2: 233.07,
    y2: 201.14,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 211.53,
    x2: 233.07,
    y2: 211.53,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 221.92,
    x2: 233.07,
    y2: 221.92,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 136.9,
    y1: 233.17,
    x2: 233.07,
    y2: 233.17,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 48.93,
    x2: 432.32,
    y2: 48.93,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 74.06,
    x2: 451.73,
    y2: 74.06,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 84.46,
    x2: 451.73,
    y2: 84.46,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 94.85,
    x2: 451.73,
    y2: 94.85,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 106.1,
    x2: 451.73,
    y2: 106.1,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 176,
    x2: 432.32,
    y2: 176,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 201.14,
    x2: 451.73,
    y2: 201.14,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 211.53,
    x2: 451.73,
    y2: 211.53,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 221.92,
    x2: 451.73,
    y2: 221.92,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 355.57,
    y1: 233.17,
    x2: 451.73,
    y2: 233.17,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 8.13,
    y: 8.87,
    width: 492.49,
    height: 32.58
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 8.13,
    y: 234.98,
    width: 492.49,
    height: 44.54
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 76.04,
    cy: 114.19,
    rx: 22.18,
    ry: 1.96
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "78.97 34.1 69.3 33.94 63.47 33.84 64.57 52.56 70.37 52.78 78.87 53.09 101.22 53.93 102.18 34.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    fillRule: "nonzero",
    points: "78.87 53.09 70.37 52.78 64.57 52.56 68.18 114.19 73.87 114.19 78.56 114.19 98.26 114.19 101.22 53.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    fillRule: "nonzero",
    points: "98.75 53.84 96.03 112.69 69.3 112.69 69.3 110.56 91.14 108.61 91.45 53.56"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "69.3 33.94 70.37 52.78 73.87 114.19 78.56 114.19 78.87 53.09 78.97 34.1"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 291.54,
    cy: 115.33,
    rx: 19.11,
    ry: 2.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291,33 L290.05,48 C290.051952,51.1894684 289.217537,54.3236958 287.63,57.09 L282.56,65.9 C282.210987,66.5086474 282.028206,67.1983888 282.029987,67.9 L282.029987,114.47 C282.029987,114.787348 282.156735,115.091554 282.382071,115.315012 C282.607407,115.53847 282.912663,115.662667 283.23,115.660042 L309.43,115.660042 C309.747337,115.662667 310.052593,115.53847 310.277929,115.315012 C310.503265,115.091554 310.63,114.787348 310.63,114.47 L310.63,68.05 C310.629626,67.3262257 310.428878,66.6166852 310.05,66 L304.95,56.94 C303.42,54.21 303.03,51.86 302.61,48 L300.85,33 L291,33 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "310.65 75.36 292.99 75.36 292.99 106.37 310.65 106.37"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    fillRule: "nonzero",
    x: 289.38,
    y: 28.88,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    fillRule: "nonzero",
    points: "300.87 32.96 291.01 32.96 290.9 34.72 301.07 34.72"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "298.29 48.08 290.11 48.08 290.64 38.91 298.29 38.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.65,76.67 C309.143134,76.8829296 307.621473,76.9732259 306.1,76.94 C303.22,77.02 299.1,77.08 294.2,77.13 L294.65,76.67 C294.65,80.89 294.65,85.67 294.71,90.81 C294.77,95.95 294.71,100.73 294.65,104.95 L294.2,104.49 C299.11,104.49 303.2,104.6 306.1,104.68 C307.621473,104.646774 309.143134,104.73707 310.65,104.95 C309.143134,105.16293 307.621473,105.253226 306.1,105.22 C303.22,105.29 299.1,105.36 294.2,105.4 L293.75,105.4 L293.75,105 C293.75,100.78 293.75,96 293.69,90.86 C293.63,85.72 293.69,80.94 293.75,76.72 L293.75,76.26 L294.2,76.26 C299.1,76.26 303.2,76.37 306.1,76.44 C307.620391,76.3935223 309.142046,76.4704411 310.65,76.67 L310.65,76.67 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,69.17 C291.03,66.48 295.76,58.52 296.26,55.17 C296.59,52.98 296.36,41.06 296.15,32.98 L293.75,32.98 C293.75,38.63 293.75,45.98 293.69,49.91 C293.5,56.79 287.4,62.05 286.05,66.63 C284.88,70.63 284.21,106.63 284.05,115.57 L290.89,115.57 C290.88,106.68 290.79,71.53 290.9,69.17 Z",
    id: "Path",
    fill: "#EDF5F6",
    fillRule: "nonzero",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    points: "453.25 8.9 373.68 88.47 182.63 279.52 246.26 279.52 373.68 152.1 500.62 25.16 500.62 8.88"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.35,
    points: "373.68 8.88 261.08 8.88 8.13 261.77 8.13 279.52 141.43 279.52 373.68 47.27 412.07 8.88"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 79.46,
    cy: 252.49,
    rx: 25.58,
    ry: 2.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.16,163.07 L108.88,163.07 L108.88,209 C108.88,217.317408 102.137408,224.06 93.82,224.06 L74.22,224.06 C65.9025917,224.06 59.16,217.317408 59.16,209 L59.16,163.07 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 80.18,
    y: 221.37,
    width: 7.69,
    height: 29.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105,252.52 L63,252.52 C63,250.115938 64.9459447,248.165514 67.35,248.16 L100.67,248.16 C101.826344,248.16 102.935327,248.619356 103.752986,249.437014 C104.570644,250.254673 105.03,251.363656 105.03,252.52 L105,252.52 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 63.78,
    y: 182.54,
    width: 40.5,
    height: 11.02
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.78,189.72 L63.78,203.56 C63.7855162,212.333519 70.8964812,219.444484 79.67,219.45 L88.38,219.45 C97.1512363,219.438981 104.258981,212.331236 104.27,203.56 L104.27,189.72 L63.78,189.72 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,163.07 C63.96,174.82 64.73,213.87 68.27,223.17 C69.8332439,223.759365 71.4893569,224.064171 73.16,224.07 L77.32,224.07 C76.12,217.89 70.04,185.68 69.67,163.07 L63.81,163.07 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 288.81,
    cy: 256.69,
    rx: 19.75,
    ry: 1.96
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "300.67 253.73 292.12 253.73 278.97 166.91 313.83 166.91"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8963D",
    fillRule: "nonzero",
    points: "294.38 251.1 285.15 190.15 307.64 190.15 298.41 251.1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 282.25,
    y: 252.08,
    width: 26.31,
    height: 4.6
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "298.41 252.08 285.94 166.91 285.66 166.91 293.74 252.08"
  }), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#122737",
    fillRule: "nonzero",
    transform: "translate(804.820000, 144.200000) rotate(90.000000) translate(-804.820000, -144.200000) ",
    x: 661.51,
    y: -110.03,
    width: 286.62,
    height: 508.46
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 558.58,
    y: 8.87,
    width: 492.49,
    height: 270.65
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 48.93,
    x2: 764.1,
    y2: 48.93,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 74.06,
    x2: 783.51,
    y2: 74.06,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 84.46,
    x2: 783.51,
    y2: 84.46,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 94.85,
    x2: 783.51,
    y2: 94.85,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 106.1,
    x2: 783.51,
    y2: 106.1,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 176,
    x2: 764.1,
    y2: 176,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 201.14,
    x2: 783.51,
    y2: 201.14,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 211.53,
    x2: 783.51,
    y2: 211.53,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 221.92,
    x2: 783.51,
    y2: 221.92,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 687.35,
    y1: 233.17,
    x2: 783.51,
    y2: 233.17,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 48.93,
    x2: 982.77,
    y2: 48.93,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 74.06,
    x2: 1002.18,
    y2: 74.06,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 84.46,
    x2: 1002.18,
    y2: 84.46,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 94.85,
    x2: 1002.18,
    y2: 94.85,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 106.1,
    x2: 1002.18,
    y2: 106.1,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 176,
    x2: 982.77,
    y2: 176,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 201.14,
    x2: 1002.18,
    y2: 201.14,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 211.53,
    x2: 1002.18,
    y2: 211.53,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 221.92,
    x2: 1002.18,
    y2: 221.92,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 906.02,
    y1: 233.17,
    x2: 1002.18,
    y2: 233.17,
    id: "Path",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 558.58,
    y: 8.87,
    width: 492.49,
    height: 32.58
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    x: 558.58,
    y: 234.98,
    width: 492.49,
    height: 44.54
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 626.49,
    cy: 114.19,
    rx: 22.18,
    ry: 1.96
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "629.42 34.1 619.75 33.94 613.92 33.84 615.02 52.56 620.82 52.78 629.32 53.09 651.67 53.93 652.63 34.51"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    fillRule: "nonzero",
    points: "629.32 53.09 620.82 52.78 615.02 52.56 618.63 114.19 624.32 114.19 629 114.19 648.71 114.19 651.67 53.93"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    fillRule: "nonzero",
    points: "649.2 53.84 646.48 112.69 619.75 112.69 619.75 110.56 641.59 108.61 641.9 53.56"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "619.75 33.94 620.82 52.78 624.32 114.19 629 114.19 629.32 53.09 629.42 34.1"
  }), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 841.99,
    cy: 115.33,
    rx: 19.11,
    ry: 2.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M841.46,33 L840.52,48 C840.521952,51.1894684 839.687537,54.3236958 838.1,57.09 L833.03,65.9 C832.67695,66.5069813 832.493873,67.1978369 832.499851,67.9 L832.499851,114.47 C832.499851,114.787348 832.626735,115.091554 832.852071,115.315012 C833.077407,115.53847 833.382663,115.662667 833.7,115.660042 L859.9,115.660042 C860.217337,115.662667 860.522593,115.53847 860.747929,115.315012 C860.973265,115.091554 861.1,114.787348 861.1,114.47 L861.1,68.05 C861.099626,67.3262257 860.898878,66.6166852 860.52,66 L855.42,56.94 C853.88,54.21 853.5,51.86 853.08,48 L851.32,33 L841.46,33 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "861.1 75.36 843.44 75.36 843.44 106.37 861.1 106.37"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    fillRule: "nonzero",
    x: 839.83,
    y: 28.88,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    fillRule: "nonzero",
    points: "851.32 32.96 841.46 32.96 841.35 34.72 851.52 34.72"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    fillRule: "nonzero",
    points: "848.74 48.08 840.56 48.08 841.09 38.91 848.74 38.91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M861.1,76.67 C859.593134,76.8829296 858.071473,76.9732259 856.55,76.94 C853.67,77.02 849.55,77.08 844.65,77.13 L845.1,76.67 C845.1,80.89 845.1,85.67 845.16,90.81 C845.22,95.95 845.16,100.73 845.1,104.95 L844.65,104.49 C849.55,104.49 853.65,104.6 856.55,104.68 C858.071473,104.646774 859.593134,104.73707 861.1,104.95 C859.593134,105.16293 858.071473,105.253226 856.55,105.22 C853.67,105.29 849.55,105.36 844.65,105.4 L844.2,105.4 L844.2,105 C844.2,100.78 844.2,96 844.14,90.86 C844.08,85.72 844.14,80.94 844.2,76.72 L844.2,76.26 L844.65,76.26 C849.55,76.26 853.65,76.37 856.55,76.44 C858.070391,76.3935223 859.592046,76.4704411 861.1,76.67 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M841.35,69.17 C841.48,66.48 846.21,58.52 846.71,55.17 C847.04,52.98 846.81,41.06 846.6,32.98 L844.2,32.98 C844.2,38.63 844.2,45.98 844.14,49.91 C843.95,56.79 837.85,62.05 836.5,66.63 C835.32,70.63 834.66,106.63 834.5,115.57 L841.34,115.57 C841.32,106.68 841.24,71.53 841.35,69.17 Z",
    id: "Path",
    fill: "#EDF5F6",
    fillRule: "nonzero",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  }), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.53,
    points: "1003.7 8.9 924.13 88.47 733.08 279.52 796.71 279.52 924.13 152.1 1051.07 25.16 1051.07 8.88"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.35,
    points: "924.13 8.88 811.53 8.88 558.58 261.77 558.58 279.52 691.88 279.52 924.13 47.27 962.52 8.88"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 629.91,
    cy: 252.49,
    rx: 25.58,
    ry: 2.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M609.61,163.07 L659.33,163.07 L659.33,209 C659.33,217.317408 652.587408,224.06 644.27,224.06 L624.67,224.06 C616.352592,224.06 609.61,217.317408 609.61,209 L609.61,163.07 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 630.63,
    y: 221.37,
    width: 7.69,
    height: 29.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M655.49,252.52 L613.49,252.52 C613.49,250.115938 615.435945,248.165514 617.84,248.16 L651.16,248.16 C652.316344,248.16 653.425327,248.619356 654.242986,249.437014 C655.060644,250.254673 655.52,251.363656 655.52,252.52 L655.49,252.52 Z",
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    fillRule: "nonzero",
    x: 614.23,
    y: 182.54,
    width: 40.5,
    height: 11.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M614.23,189.72 L614.23,203.56 C614.235516,212.333519 621.346481,219.444484 630.12,219.45 L638.83,219.45 C647.601236,219.438981 654.708981,212.331236 654.72,203.56 L654.72,189.72 L614.23,189.72 Z",
    id: "Path",
    fill: "#E32D27",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,163.07 C614.41,174.82 615.18,213.87 618.72,223.17 C620.282777,223.761041 621.939196,224.065903 623.61,224.07 L627.77,224.07 C626.56,217.89 620.49,185.68 620.12,163.07 L614.26,163.07 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    }
  }), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#471117",
    fillRule: "nonzero",
    cx: 839.26,
    cy: 256.69,
    rx: 19.75,
    ry: 1.96
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    points: "851.12 253.73 842.57 253.73 829.42 166.91 864.27 166.91"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8963D",
    fillRule: "nonzero",
    points: "844.83 251.1 835.6 190.15 858.09 190.15 848.86 251.1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    fillRule: "nonzero",
    x: 832.7,
    y: 252.08,
    width: 26.31,
    height: 4.6
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "screen"
    },
    points: "848.86 252.08 836.39 166.91 836.11 166.91 844.19 252.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TABLE",
    transform: "translate(287.000000, 683.000000)"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#752A31",
    fillRule: "nonzero",
    x: 29.73,
    y: 43.97,
    width: 1057.8,
    height: 488.44
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#752A31",
    fillRule: "nonzero",
    x: 0.52,
    y: 0.61,
    width: 1115.68,
    height: 47.82
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.52,545.88 L1116.2,545.88 C1116.2,527.5 1098.94,512.59 1077.65,512.59 L39.07,512.59 C17.78,512.59 0.52,527.5 0.52,545.88 Z",
    id: "Path",
    fill: "#752A31"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#471117",
    fillRule: "nonzero",
    x: 29.73,
    y: 46.68,
    width: 1057.8,
    height: 16.84
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#9A4E57",
    fillRule: "nonzero",
    x: 29.73,
    y: 131.46,
    width: 1057.27,
    height: 313.45
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M532.94,444.92 L528,444.92 L528,131.46 L532.9,131.46 L532.94,444.92 Z M588.69,131.46 L583.78,131.46 L583.78,444.92 L588.69,444.92 L588.69,131.46 Z M421.45,131.46 L416.55,131.46 L416.55,444.92 L421.45,444.92 L421.45,131.46 Z M755.92,131.46 L751,131.46 L751,444.92 L755.9,444.92 L755.92,131.46 Z M644.43,131.46 L639.53,131.46 L639.53,444.92 L644.43,444.92 L644.43,131.46 Z M700.18,131.46 L695.27,131.46 L695.27,444.92 L700.18,444.92 L700.18,131.46 Z M477.18,131.46 L472.28,131.46 L472.28,444.92 L477.18,444.92 L477.18,131.46 Z M82.07,444.92 L87,444.92 L87,131.46 L82.09,131.46 L82.07,444.92 Z M142.72,131.46 L137.82,131.46 L137.82,444.92 L142.72,444.92 L142.72,131.46 Z M198.47,131.46 L193.56,131.46 L193.56,444.92 L198.47,444.92 L198.47,131.46 Z M365.71,131.46 L360.8,131.46 L360.8,444.92 L365.71,444.92 L365.71,131.46 Z M254.21,131.46 L249.31,131.46 L249.31,444.92 L254.21,444.92 L254.21,131.46 Z M309.96,131.46 L305.05,131.46 L305.05,444.92 L310,444.92 L309.96,131.46 Z M978.96,131.46 L974,131.46 L974,444.92 L978.91,444.92 L978.96,131.46 Z M811.72,131.46 L806.82,131.46 L806.82,444.92 L811.72,444.92 L811.72,131.46 Z M867.46,131.46 L862.56,131.46 L862.56,444.92 L867.46,444.92 L867.46,131.46 Z M923.21,131.46 L918.3,131.46 L918.3,444.92 L923.21,444.92 L923.21,131.46 Z M1034.7,131.46 L1029.8,131.46 L1029.8,444.92 L1034.7,444.92 L1034.7,131.46 Z",
    id: "Shape",
    fill: "#752A31",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,199.17 L258.27,181.27 L276.2,181.27 C282.57,169.12 285.6,157.12 284.66,145.27 C284.289281,141.84204 281.603153,139.122751 278.18,138.71 C214.254003,129.034925 149.235997,129.034925 85.31,138.71 C81.933506,139.137946 79.273168,141.794172 78.84,145.17 C77.56,157.58 80.74,169.68 87.42,181.25 L105.12,181.25 L107.07,199.15 L112.07,199.15 L90.57,545.86 L99.12,545.86 L132.9,199.15 L180.75,199.15 L192.87,447.84 L109,447.84 L106.69,468 L193.83,468 L197.62,545.9 L206.17,545.9 L205.17,468 L253.4,468 L260.99,545.9 L269.54,545.9 L248,199.17 L256.27,199.17 Z M251.4,447.86 L204.87,447.86 L201.56,199.17 L227.17,199.17 L251.4,447.86 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.34,199.17 L624.29,181.27 L642.22,181.27 C648.59,169.12 651.61,157.12 650.68,145.27 C650.309281,141.84204 647.623153,139.122751 644.2,138.71 C580.270647,129.034979 515.249353,129.034979 451.32,138.71 C447.947398,139.142155 445.292155,141.797398 444.86,145.17 C443.58,157.58 446.76,169.68 453.44,181.25 L471.14,181.25 L473.14,199.15 L478.14,199.15 L456.64,545.86 L465.19,545.86 L499,199.17 L546.8,199.17 L558.91,447.86 L475.09,447.86 L472.76,468 L559.89,468 L563.69,545.9 L572.24,545.9 L571.24,468 L619.47,468 L627.06,545.9 L635.6,545.9 L614.07,199.17 L622.34,199.17 Z M617.47,447.86 L570.93,447.86 L567.63,199.17 L593.24,199.17 L617.47,447.86 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005,199.17 L1007,181.27 L1024.92,181.27 C1031.3,169.12 1034.32,157.12 1033.39,145.27 C1033.01224,141.845392 1030.32972,139.129754 1026.91,138.71 C962.980647,129.034979 897.959353,129.034979 834.03,138.71 C830.655142,139.141285 827.996504,141.795813 827.56,145.17 C826.29,157.58 829.47,169.68 836.15,181.25 L853.85,181.25 L855.85,199.15 L860.85,199.15 L839.35,545.86 L847.9,545.86 L881.68,199.15 L929.52,199.15 L941.64,447.84 L857.82,447.84 L855.49,467.96 L942.62,467.96 L946.42,545.86 L954.96,545.86 L953.96,467.96 L1002.18,467.96 L1009.77,545.86 L1018.32,545.86 L996.82,199.15 L1005,199.17 Z M1000.12,447.86 L953.59,447.86 L950.29,199.17 L975.89,199.17 L1000.12,447.86 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHAIRS",
    transform: "translate(376.000000, 812.000000)",
    fillRule: "nonzero"
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "31.34 316.85 182.04 316.85 184.53 336.96 29.01 336.96"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.47,50.25 L9.69,50.25 C3.01,38.68 -0.17,26.58 1.1,14.17 C1.53737244,10.7980653 4.19672732,8.14693094 7.57,7.72 C71.4985978,-1.96505243 136.521402,-1.96505243 200.45,7.72 C203.87488,8.12922601 206.562826,10.8503572 206.93,14.28 C207.86,26.1 204.84,38.1 198.47,50.25 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "178.59 68.15 29.34 68.15 27.39 50.25 180.54 50.25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2,68.15 L19.39,435.63 L11.58,435.63 L34.37,68.15 L55.2,68.15 Z M103.05,68.15 L121,435.63 L128.81,435.63 L123.93,68.15 L103.05,68.15 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "149.48 68.15 185.29 435.63 193.1 435.63 170.32 68.15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.59,14.22 C7.18,23.22 8.74,33.22 12.71,43.95 L65.71,43.95 L85.85,12.73 C121.85,12.24 159.85,12.83 199.45,14.22 C190.3,3.82 31.64,0.45 9.59,14.22 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "192.7 18.57 188.38 43.95 141.65 43.95 137.33 17.26"
  }), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "397.41 316.85 548.11 316.85 550.6 336.96 395.08 336.96"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M564.54,50.25 L375.76,50.25 C369.08,38.68 365.9,26.58 367.17,14.17 C367.604031,10.7964194 370.265092,8.14358466 373.64,7.72 C437.568598,-1.96505243 502.591402,-1.96505243 566.52,7.72 C569.943153,8.13275072 572.629281,10.8520404 573,14.28 C573.93,26.1 570.91,38.1 564.54,50.25 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "544.66 68.15 395.4 68.15 393.46 50.25 546.61 50.25"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M421.27,68.15 L385.46,435.63 L377.65,435.63 L400.44,68.15 L421.27,68.15 Z M469.12,68.15 L487,435.63 L494.81,435.63 L490,68.15 L469.12,68.15 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "515.55 68.15 551.36 435.63 559.17 435.63 536.38 68.15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.66,14.22 C373.25,23.22 374.81,33.22 378.77,43.95 L431.77,43.95 L451.9,12.73 C487.9,12.24 525.9,12.83 565.51,14.22 C556.37,3.82 397.71,0.45 375.66,14.22 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "558.77 18.57 554.45 43.95 507.72 43.95 503.4 17.26"
  }), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "780.1 316.85 930.8 316.85 933.29 336.96 777.77 336.96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M947.23,50.25 L758.46,50.25 C751.78,38.68 748.6,26.58 749.87,14.17 C750.304031,10.7964194 752.965092,8.14358466 756.34,7.72 C820.268598,-1.96505243 885.291402,-1.96505243 949.22,7.72 C952.643153,8.13275072 955.329281,10.8520404 955.7,14.28 C956.63,26.1 953.6,38.1 947.23,50.25 Z",
    id: "Path",
    fill: "#F26341"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "927.35 68.15 778.1 68.15 776.15 50.25 929.3 50.25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M804,68.15 L768.2,435.63 L760.39,435.63 L783.17,68.15 L804,68.15 Z M851.85,68.15 L869.75,435.63 L877.57,435.63 L872.68,68.15 L851.85,68.15 Z",
    id: "Shape",
    fill: "#27384A"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "898.25 68.15 934.05 435.63 941.87 435.63 919.08 68.15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.36,14.22 C755.95,23.22 757.51,33.22 761.47,43.95 L814.47,43.95 L834.6,12.73 C870.6,12.24 908.6,12.83 948.2,14.22 C939.07,3.82 780.41,0.45 758.36,14.22 Z",
    id: "Path",
    fill: "#EDE0A0",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AB1E36",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    points: "941.46 18.57 937.15 43.95 890.41 43.95 886.1 17.26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CASHIER",
    transform: "translate(337.000000, 552.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1A2430",
    points: "108.34 10.5 108.34 51.35 23.73 51.35 22.77 10.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#27384A",
    points: "22.77 10.5 23.73 51.35 19.78 51.35 19.78 10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,10.5 L19.78,10.5 L19.78,51.35 L108.34,51.35 L108.34,10.5 Z M117.16,0.79 L124.16,118.06 L6.9,118.06 L11.62,0.79 L117.16,0.79 Z",
    id: "Shape",
    fill: "#226BB5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#226BB5",
    points: "126.57 118.06 127.82 131.61 0.22 131.61 2.21 118.06 6.9 118.06 124.21 118.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#125285",
    points: "210.4 118.06 212.4 131.61 127.82 131.61 126.57 118.06 206.01 118.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#094166",
    points: "199.81 82.16 206.01 118.06 126.57 118.06 124.21 118.06 117.16 0.79 139.11 3.93 154.21 62.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FCD828",
    points: "51.74 30.4 35.69 30.25 35.06 24.36 53.04 24.53 53.04 19.3 45.72 19.36 45.88 15.88 37.4 15.88 37.57 19.44 31.73 19.49 28.32 19.52 28.68 22.15 30.13 32.74 30.42 34.84 33.02 34.82 48.82 34.67 48.4 38.62 32.98 38.76 32.98 42.49 38.14 42.53 38.29 45.82 45 45.82 45.14 42.6 50.75 42.65 53.05 42.67 53.31 40.82 54.42 32.73 54.73 30.43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DRINKS",
    transform: "translate(822.000000, 594.000000)",
    fillRule: "nonzero"
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    points: "451.34 24.73 443.49 24.6 438.77 24.52 439.66 39.69 444.37 39.87 451.26 40.12 469.37 40.8 470.15 25.06"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    points: "451.26 40.12 444.37 39.87 439.66 39.69 442.59 89.64 447.2 89.64 451 89.64 466.97 89.64 469.37 40.8"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    points: "467.37 40.73 465.17 88.43 443.49 88.43 443.49 86.7 461.2 85.12 461.45 40.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    style: {
      mixBlendMode: "screen"
    },
    points: "443.49 24.6 444.37 39.87 447.2 89.64 451 89.64 451.26 40.12 451.34 24.73"
  }), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EDD5AC",
    points: "487.2 24.73 479.36 24.6 474.64 24.52 475.53 39.69 480.23 39.87 487.12 40.12 505.24 40.8 506.01 25.06"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4BC54",
    points: "487.12 40.12 480.23 39.87 475.53 39.69 478.45 89.64 483.07 89.64 486.87 89.64 502.83 89.64 505.24 40.8"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BF7A2A",
    points: "503.24 40.73 501.03 88.43 479.36 88.43 479.36 86.7 497.07 85.12 497.32 40.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    style: {
      mixBlendMode: "screen"
    },
    points: "479.36 24.6 480.23 39.87 483.07 89.64 486.87 89.64 487.12 40.12 487.2 24.73"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.8,0.16 L431.52,0.16 L431.52,46.1 C431.52,54.4174083 424.777408,61.16 416.46,61.16 L396.86,61.16 C388.542592,61.16 381.8,54.4174083 381.8,46.1 L381.8,0.16 L381.8,0.16 Z",
    id: "Path",
    fill: "#EDD5AC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EDD5AC",
    x: 402.82,
    y: 58.46,
    width: 7.69,
    height: 29.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M427.68,89.61 L385.679988,89.61 C385.677344,88.4545766 386.134473,87.3455663 386.950545,86.527619 C387.766616,85.7096717 388.874574,85.25 390.03,85.25 L423.35,85.25 C425.757962,85.25 427.71,87.2020385 427.71,89.61 L427.68,89.61 Z",
    id: "Path",
    fill: "#EDD5AC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF7D0",
    x: 386.41,
    y: 19.63,
    width: 40.5,
    height: 11.02
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M386.41,26.81 L386.41,40.65 C386.421029,49.4251361 393.534859,56.5344914 402.31,56.54 L411,56.54 C419.771236,56.5289808 426.878981,49.4212363 426.89,40.65 L426.89,26.81 L386.41,26.81 Z",
    id: "Path",
    fill: "#E32D27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.45,0.16 C386.6,11.91 387.37,50.96 390.91,60.26 C392.472777,60.8510406 394.129196,61.155903 395.8,61.16 L400,61.16 C398.79,54.98 392.72,22.77 392.35,0.16 L386.45,0.16 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51,7 L50.06,22 C50.0593762,25.1904348 49.221466,28.3248399 47.63,31.09 L42.56,39.91 C42.2144782,40.5196116 42.0351607,41.2092945 42.0399046,41.91 L42.0399046,88.48 C42.0373332,88.7973367 42.1615296,89.1025932 42.3849876,89.327929 C42.6084456,89.5532648 42.9126521,89.68 43.23,89.68 L69.43,89.68 C70.0927417,89.68 70.6300034,89.1427417 70.6300034,88.48 L70.6300034,42.18 C70.6309522,41.4529009 70.4301739,40.7397918 70.05,40.12 L64.95,31.12 C63.42,28.39 63.03,26.04 62.61,22.12 L60.85,7.12 L51,7 Z",
    id: "Path",
    fill: "#E32D27"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    points: "70.65 49.41 53 49.41 53 80.42 70.65 80.42"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    x: 49.38,
    y: 2.94,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    points: "60.87 7.01 51.02 7.01 50.91 8.78 61.08 8.78"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    points: "58.29 22.13 50.12 22.13 50.64 12.96 58.29 12.96"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.65,50.73 C69.1464653,50.9426958 67.6281461,51.0329924 66.11,51 C63.22,51.07 59.11,51.14 54.2,51.18 L54.66,50.73 C54.66,54.95 54.66,59.73 54.72,64.86 C54.78,69.99 54.67,74.78 54.66,79 L54.2,78.55 C59.11,78.55 63.2,78.66 66.11,78.73 C67.6281461,78.6970076 69.1464653,78.7873042 70.65,79 C69.1464653,79.2126958 67.6281461,79.3029924 66.11,79.27 C63.22,79.35 59.11,79.41 54.2,79.46 L53.75,79.46 L53.75,79 C53.75,74.78 53.75,70 53.69,64.86 C53.63,59.72 53.69,54.95 53.75,50.73 L53.75,50.27 L54.2,50.27 C59.11,50.32 63.2,50.38 66.11,50.46 C67.6281461,50.4270076 69.1464653,50.5173042 70.65,50.73 Z",
    id: "Path",
    fill: "#E32D27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.91,43.23 C51.04,40.53 55.76,32.58 56.27,29.23 C56.59,27.04 56.36,15.12 56.16,7.03 L53.75,7.03 C53.75,12.69 53.75,20.03 53.69,23.97 C53.5,30.84 47.41,36.1 46.06,40.69 C44.88,44.69 44.21,80.69 44.06,89.63 L50.89,89.63 C50.88,80.73 50.79,45.58 50.91,43.23 Z",
    id: "Path",
    fill: "#EDF5F6",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87,7 L8.93,22 C8.93288624,25.1895903 8.09840835,28.3240547 6.51,31.09 L1.44,39.91 C1.09098737,40.5186474 0.908205893,41.2083888 0.909986919,41.91 L0.909986919,88.48 C0.909986919,89.1427417 1.4472583,89.68 2.11,89.68 L28.31,89.68 C28.6282598,89.68 28.9334845,89.5535718 29.1585281,89.3285281 C29.3835718,89.1034845 29.5100034,88.7982598 29.5100034,88.48 L29.5100034,42.18 C29.5109522,41.4529009 29.3101739,40.7397918 28.93,40.12 L23.83,31.12 C22.29,28.39 21.91,26.04 21.49,22.12 L19.73,7.12 L9.87,7 Z",
    id: "Path",
    fill: "#E32D27"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    points: "29.51 49.41 11.85 49.41 11.85 80.42 29.51 80.42"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    x: 8.24,
    y: 2.94,
    width: 13.12,
    height: 4.17,
    rx: 0.93
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BE1E2D",
    points: "19.73 7.01 9.88 7.01 9.76 8.78 19.93 8.78"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    points: "17.15 22.13 8.97 22.13 9.5 12.96 17.15 12.96"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.51,50.73 C28.0163377,50.940778 26.508141,51.0310691 25,51 C22.12,51.07 18,51.14 13.1,51.18 L13.55,50.73 C13.55,54.95 13.55,59.73 13.61,64.86 C13.67,69.99 13.61,74.78 13.55,79 L13.1,78.55 C18.01,78.55 22.1,78.66 25,78.73 C26.5214732,78.6967741 28.0431338,78.7870704 29.55,79 C28.0431338,79.2129296 26.5214732,79.3032259 25,79.27 C22.12,79.35 18,79.41 13.1,79.46 L12.65,79.46 L12.65,79 C12.65,74.78 12.65,70 12.59,64.86 C12.53,59.72 12.59,54.95 12.65,50.73 L12.65,50.27 L13.1,50.27 C18,50.32 22.1,50.38 25,50.46 C26.508141,50.4289309 28.0163377,50.519222 29.51,50.73 L29.51,50.73 Z",
    id: "Path",
    fill: "#E32D27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.76,43.23 C9.89,40.53 14.62,32.58 15.12,29.23 C15.45,27.04 15.22,15.12 15.01,7.03 L12.61,7.03 C12.61,12.69 12.61,20.03 12.55,23.97 C12.36,30.84 6.26,36.1 4.91,40.69 C3.74,44.69 3.07,80.69 2.91,89.63 L9.75,89.63 C9.73,80.73 9.65,45.58 9.76,43.23 Z",
    id: "Path",
    fill: "#EDF5F6",
    opacity: 0.33,
    style: {
      mixBlendMode: "screen"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "MAN_1",
    transform: "translate(798.000000, 334.000000)",
    fillRule: "nonzero"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SHOES",
    transform: "translate(33.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.32,14.54 L54.4,0.54 L102.01,7.54 L97.87,54.38 L29,44.73 L24.45,24.37 C37.72,19.7 52.32,14.54 52.32,14.54 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,31.76 C3.76,31.6 13.69,28.15 24.45,24.37 L29,44.73 L1.16,40.82 C1.41,36.81 2,32 3,31.76 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.82,46.17 C0.82,46.17 0.9,43.7 1.11,40.82 L97.87,54.42 L97.46,59.04 L0.82,46.17 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,20.71 C31.85,20.71 33.85,28.09 34.61,28.27 C35.37,28.45 40.61,28.54 40.49,26.76 C40.37,24.98 39.19,18.19 36.95,18.5 C34.71,18.81 31.46,19.3 31.85,20.71 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08,16.63 C42.08,16.63 44.08,24.01 44.85,24.2 C45.62,24.39 50.85,24.47 50.73,22.68 C50.61,20.89 49.42,14.12 47.19,14.43 C44.96,14.74 41.69,15.23 42.08,16.63 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,60.35 L288.3,54.96 C263.78,64.74 210.6,65.85 199.69,65.96 C199.85176,67.3048733 200.085428,68.6401187 200.39,69.96 C259.6,75.2 289,60.35 289,60.35 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56,52 C235.79,54.18 236.67,59.06 237.29,64.25 C255.44,62.77 275.7,60.03 288.29,54.99 L285.11,30.26 L283.21,13.48 L234,23.21 C234,23.21 221,36.69 211.25,46.81 C218.19,46.91 232.14,47.7 234.56,52 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.73,66 C205.02,65.94 220.22,65.65 237.29,64.25 C236.67,59.06 235.79,54.18 234.56,52 C232.14,47.73 218.19,46.94 211.3,46.81 C206.14,52.17 201.87,56.58 200.9,57.57 C199.3,59.18 199.37,63 199.73,66 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,26.43 C238.21,26.43 251.46,28.79 251.38,32.18 C251.3,35.57 248.91,36.74 248.08,36.49 C247.25,36.24 236.15,31.89 233.85,31.76 C228.74,31.48 232.55,26.46 235.86,26.43 Z",
    id: "Path",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,34.22 C232.14,34.22 245.4,36.58 245.31,39.97 C245.22,43.36 242.84,44.53 242.01,44.28 C241.18,44.03 230.08,39.67 227.78,39.55 C222.68,39.26 226.48,34.25 229.79,34.22 Z",
    id: "Path",
    fill: "#231F20"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ARMS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,215.8 C356,215.8 387.15,273.64 387.15,290.22 C387.15,306.8 356,408.88 356,408.88 C356,408.88 359.78,408.61 359.51,416.97 C359.24,425.33 360.86,444.74 360.86,444.74 C360.86,444.74 342,449.06 335,448 C328,446.94 313.43,423.46 318.55,408.36 C323.67,393.26 326.64,384.9 328.26,375.46 C329.88,366.02 336.35,293.32 336.35,293.32 L313.16,243.86 L356,215.8 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.83,166.34 L103,174.86 C103,174.86 56,106.55 53.72,104.08 C53.23,103.55 51.19,103.42 48.3,103.56 L37.67,98.39 C37.67,98.39 26.12,91.45 20.42,86.99 L11.42,99.59 C13.186235,102.287493 14.8117405,105.07455 16.29,107.94 L45.91,185.62 C52.16,210.54 64.31,225.71 77.77,228.08 L189.66,220.77 L171.83,166.34 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,133.32 C44.17,130.52 37.7,98.39 37.7,98.39 C24.91,101.88 20.46,109.24 19.63,116.64 L27.48,137.25 C32.78,136.7 43.11,135.39 43.56,133.32 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,40.6 L10.03,57.6 C10.3982379,61.2081457 9.81200047,64.8497147 8.33,68.16 L3.61,78.72 C3.28859057,79.4343225 3.16097747,80.2206951 3.24,81 L8.58,133.68 C8.6153661,134.039552 8.79234344,134.370255 9.07188044,134.599138 C9.35141743,134.82802 9.71053833,134.93627 10.07,134.9 L39.72,131.9 C40.07883,131.864737 40.4086437,131.687399 40.6359385,131.407507 C40.8632332,131.127615 40.9691197,130.76843 40.93,130.41 L35.62,78.03 C35.5381308,77.2088358 35.2300378,76.4264872 34.73,75.77 L27.92,66.11 C25.92,63.2 25.16,60.59 24.24,56.26 L20.53,39.45 L9.38,40.6 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    points: "36.46 86.31 16.48 88.34 20.04 123.42 40.02 121.39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    transform: "translate(14.719803, 37.804074) rotate(-5.790000) translate(-14.719803, -37.804074) ",
    x: 7.25480307,
    y: 35.4340742,
    width: 14.93,
    height: 4.74,
    rx: 0.83
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    points: "19.34 56.87 10.1 57.81 9.64 47.37 18.29 46.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24,103.85 C38.540403,106.787689 37.0413431,109.617009 34.442003,111.018326 C31.8426629,112.419643 28.6550958,112.116905 26.3660281,110.251315 C24.0769604,108.385725 23.1373237,105.324791 23.9853778,102.496176 C24.8334319,99.6675614 27.3021157,97.6284846 30.24,97.33 C34.2474659,96.9283782 37.8248138,99.8439167 38.24,103.85 L38.24,103.85 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.61,87.8 C36.61,87.93 34.76,88.24 31.5,88.68 C28.24,89.12 23.6,89.68 18.06,90.29 L18.6,89.63 C19.11,94.42 19.69,99.85 20.3,105.63 C20.91,111.41 21.38,116.84 21.84,121.63 L21.18,121.09 C26.74,120.58 31.4,120.19 34.68,119.97 C37.96,119.75 39.84,119.67 39.8500401,119.8 C39.86,119.93 38,120.24 34.75,120.68 C31.5,121.12 26.85,121.68 21.31,122.29 L20.71,122.35 L20.64,121.75 C20.14,116.96 19.56,111.52 18.95,105.75 C18.34,99.98 17.86,94.54 17.4,89.75 L17.34,89.14 L17.94,89.09 C23.49,88.58 28.15,88.19 31.43,87.97 C34.71,87.75 36.6,87.67 36.61,87.8 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.81,24.47 C14.41,21.6 12.98,18.65 12.69,15.47 C12.4,12.29 13.51,8.78 16.21,7.07 C18.91,5.36 23.21,6.35 24.21,9.4 C25.06,12.05 23.27,14.79 21.39,16.85 C19.51,18.91 16.01,21.69 15.84,24.47",
    id: "Path",
    fill: "#82B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69,17.56 C5.83572317,15.1428292 2.82178434,11.5945536 1.06,7.4 C0.37,5.75 -0.09,3.77 0.81,2.22 C1.61606225,0.964733579 3.06899016,0.281002798 4.55,0.46 C6.0158575,0.663182395 7.32916422,1.47220835 8.17,2.69 C9.63,4.69 9.76,7.43 9.65,9.94 C9.54,12.45 9.24,15.04 10.02,17.43",
    id: "Path",
    fill: "#82B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.94,87.73 C38.44,86.47 29.2,84.16 23.04,83.36 C19.88,82.95 17.53,82.93 17.34,83.66 C17.2,84.22 18.48,85.46 20.45,86.99 C26.15,91.45 37.7,98.39 37.7,98.39 L55.58,107.07 C55.58,107.07 44.72,89.65 40.94,87.73 Z",
    id: "Path",
    fill: "#F8A89A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PANTS",
    transform: "translate(73.000000, 367.000000)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.49,15.08 L0.25,522.76 C0.25,522.76 27.39,541.76 68.65,537.94 L146.74,139.76 L174.22,544.43 L249.04,539.8 L230.59,0.38 L90.49,15.08 Z",
    id: "Path",
    fill: "#2B2D6E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.58,111.45 C146.329995,111.362606 146.091571,111.245073 145.87,111.1 C145.244406,110.654336 144.719686,110.081913 144.33,109.42 C142.939873,106.976689 141.92837,104.336666 141.33,101.59 C139.57,94.72 138.33,85.03 137.65,74.31 C136.97,63.59 137.05,53.86 137.22,46.83 C137.39,39.8 137.69,35.46 137.69,35.46 C137.69,35.46 137.91,39.81 138.28,46.82 C138.65,53.83 139.13,63.51 139.77,74.18 C140.41,84.85 141.15,94.49 142.37,101.36 C142.757989,104.082088 143.511451,106.739388 144.61,109.26 C144.926068,109.93302 145.375081,110.535106 145.93,111.03 C146.127214,111.198029 146.345773,111.339252 146.58,111.45 L146.58,111.45 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224,50.78 L222.31,50.89 C221.64386,50.9274617 220.97614,50.9274617 220.31,50.89 C219.92,50.89 219.51,50.89 219.06,50.89 L217.67,50.76 C215.351851,50.5323317 213.074808,49.9941827 210.9,49.16 C208.206492,48.0996361 205.734261,46.5464375 203.61,44.58 C201.5082,42.5989867 199.771682,40.2633187 198.48,37.68 C197.436438,35.6094576 196.647365,33.4201993 196.13,31.16 C195.782978,29.649893 195.552301,28.1153919 195.44,26.57 C195.411167,26.0070356 195.411167,25.4429644 195.44,24.88 C195.845039,26.927746 196.430661,28.9355916 197.19,30.88 C198.854872,35.4528886 201.523631,39.5944208 205,43 C206.959243,44.8045019 209.168689,46.3167601 211.56,47.49 C213.559636,48.4339602 215.650495,49.1711221 217.8,49.69 L219.13,50 L220.33,50.22 C221.08,50.36 221.73,50.47 222.27,50.52 L224,50.78 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35,54.18 L87.44,53.7 C88.4016023,53.2500678 89.318943,52.7110465 90.18,52.09 C92.8917153,50.0146582 94.9698012,47.2230961 96.18,44.03 C97.4536196,40.8089498 98.3593603,37.4543548 98.88,34.03 C99.32,31.35 99.44,29.64 99.44,29.64 C99.7466003,31.1076271 99.9140092,32.6009144 99.94,34.1 C100.096513,37.7761748 99.4834211,41.4445106 98.14,44.87 C97.3627587,46.7905536 96.2409886,48.552851 94.83,50.07 C92.9062124,52.1428708 90.368823,53.5447434 87.59,54.07 L86.35,54.18 Z",
    id: "Path",
    fill: "#0F1235"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M133.37,42.9 C133.3152,42.6971759 133.234538,42.5022432 133.13,42.32 C132.88236,41.8754988 132.496021,41.5242816 132.03,41.32 C131.461186,41.0313717 130.788814,41.0313717 130.22,41.32 C129.641947,41.6354859 129.282322,42.2414591 129.282322,42.9 C129.282322,43.5585409 129.641947,44.1645141 130.22,44.48 C130.788814,44.7686283 131.461186,44.7686283 132.03,44.48 C132.494036,44.2726693 132.879514,43.9222348 133.13,43.48 C133.235751,43.2948178 133.316456,43.0964188 133.37,42.89 C133.430344,43.1080127 133.457317,43.3339084 133.45,43.56 C133.427363,44.240065 133.148785,44.886507 132.67,45.37 C131.869774,46.1705829 130.697761,46.4731614 129.61,46.16 C128.157616,45.738046 127.158565,44.4074364 127.158565,42.895 C127.158565,41.3825636 128.157616,40.051954 129.61,39.63 C130.697761,39.3168386 131.869774,39.6194171 132.67,40.42 C133.148145,40.8998584 133.426833,41.5429844 133.45,42.22 C133.459657,42.4494784 133.432651,42.6790283 133.37,42.9 L133.37,42.9 Z",
    id: "Path",
    fill: "#0F1235"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0F1235",
    opacity: 0.66,
    style: {
      mixBlendMode: "multiply"
    },
    points: "231.38 28.82 84.72 47.59 90.49 15.08 230.6 0.38"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.39,144.81 C260.39,144.81 305.02,147.81 319.81,160.14 C334.6,172.47 375.81,236.43 375.81,236.43 C375.81,236.43 339.01,270.6 321.38,275.9 L309.88,254.22 L307,392.58 L147,402.46 L166.68,227.12 L113.68,234.69 L113.68,166 C113.68,166 202.33,142.18 260.39,144.81 Z",
    id: "SHIRT",
    fill: "#226BB5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "HEAD",
    transform: "translate(173.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.338115,1.33852052 L85.338115,1.33852052 L85.338115,5.33852052 C85.338115,5.89080527 84.8903997,6.33852052 84.338115,6.33852052 L80.458115,6.33852052 C79.9058302,6.33852052 79.458115,5.89080527 79.458115,5.33852052 L79.458115,1.33852052 L79.338115,1.33852052 Z",
    id: "Path",
    fill: "#E7515B",
    transform: "translate(82.338115, 3.838521) rotate(-169.740000) translate(-82.338115, -3.838521) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.338115,1.33852052 L85.338115,1.33852052 L85.338115,5.33852052 C85.338115,5.89080527 84.8903997,6.33852052 84.338115,6.33852052 L80.458115,6.33852052 C79.9058302,6.33852052 79.458115,5.89080527 79.458115,5.33852052 L79.458115,1.33852052 L79.338115,1.33852052 Z",
    id: "Path",
    fill: "#000000",
    transform: "translate(82.338115, 3.838521) rotate(-169.740000) translate(-82.338115, -3.838521) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54,104.4 C67.41,104.71 67.26,105.02 67.1,105.32 C64.773212,109.863703 60.6368431,113.21438 55.7090969,114.547232 C50.7813506,115.880085 45.5199374,115.071312 41.22,112.32 C37.47,109.93 34.53,105.56 35.4,101.2 C33.89,103.33 30.54,103.54 28.4,102.07 C26.2983526,100.441114 25.0718357,97.9289707 25.08,95.27 C25.1144762,92.6517253 25.5529742,90.0544676 26.38,87.57 C24.1467021,89.4957237 20.8639599,89.5752799 18.54,87.76 C16.3216293,85.8726753 15.3287786,82.9133647 15.96,80.07 C16.6313533,77.2663956 18.3860308,74.842927 20.84,73.33 C18.6115838,73.4573229 16.4612144,72.4893449 15.0790412,70.7367334 C13.696868,68.9841219 13.2567722,66.66736 13.9,64.53 C15.06,60.67 19.27,58.65 23.16,57.62 C27.05,56.59 31.31,55.98 34.3,53.27 C36.4741284,51.1283667 37.8442998,48.303271 38.18,45.27 C38.4966334,42.2495903 38.4630774,39.2027036 38.08,36.19 L52.24,36.57 L67.54,104.4 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.33,45.23 C114.83,48.23 118.91,56.11 121.51,57.78 C124.188841,59.3193191 127.038094,60.5409072 130,61.42 C132.96589,62.3023509 135.742717,63.7263646 138.19,65.62 C140.53,67.62 142.19,70.62 141.87,73.71 C141.55,76.8 138.69,79.59 135.62,79.23 C137.62,81.67 139.54,84.17 140.56,87.12 C141.58,90.07 141.48,93.59 139.5,96.01 C137.52,98.43 133.43,99.08 131.27,96.82 C133.210498,101.493724 131.855754,106.886935 127.936944,110.088833 C124.018134,113.290731 118.463108,113.543209 114.27,110.71 C113.348731,116.167746 108.988806,120.394301 103.505081,121.145622 C98.021356,121.896943 92.6852856,118.998827 90.33,113.99",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.23,147.67 C79.04,159.39 56.6,143.86 56.6,143.86 C56.3,138.3 56.7,116.79 56.7,116.79 C56.7,116.79 36.89,113.71 36.64,93.9 C36.39,74.09 39.83,28.59 39.83,28.59 L39.83,28.59 C62.7656509,18.736317 89.2377682,22.0649399 109.02,37.29 L111.96,39.55 C111.82,39.8 104.23,147.67 104.23,147.67 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.59,58.58 C39.9,58.92 41.84,57.43 44.59,57.41 C47.34,57.39 49.3,58.81 49.59,58.41 C49.74,58.25 49.43,57.64 48.59,56.98 C46.1909506,55.2561513 42.9496605,55.2926158 40.59,57.07 C39.73,57.8 39.44,58.43 39.59,58.58 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,60 C69.54,60.35 71.48,58.85 74.23,58.84 C76.98,58.83 78.94,60.23 79.23,59.84 C79.38,59.69 79.07,59.07 78.23,58.41 C77.0664952,57.5714992 75.6640208,57.1297198 74.23,57.15 C72.7832973,57.1505725 71.377233,57.6286343 70.23,58.51 C69.37,59.24 69.08,59.86 69.23,60 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,83 C58.29,82.79 56.62,82.45 53.87,82.07 C53.16,81.99 52.6,81.83 52.55,81.44 C52.5363101,80.7395148 52.7125461,80.0483935 53.06,79.44 C53.76,77.64 54.47,75.81 55.22,73.9 C58.22,66 60.29,59.47 59.89,59.32 C59.49,59.17 56.74,65.45 53.76,73.32 C53.06,75.25 52.39,77.09 51.76,78.91 C51.2908484,79.8360054 51.1532023,80.8948212 51.37,81.91 C51.5770663,82.4628512 52.0330371,82.8854582 52.6,83.05 C52.9962715,83.1645495 53.4075917,83.2184932 53.82,83.21 C56.55,83.29 58.27,83.25 58.29,83 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67,116.5 C56.67,116.5 69.19,117.5 82.5,109.16 C82.5,109.16 76.39,123.42 56.62,121.64 L56.67,116.5 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.42,33.58 C39.42,33.58 51.02,40.29 67.24,33.63 C77.89,29.27 90.04,27.63 92.52,29.91 C95,32.19 83.3,27.59 90.89,43.8 C90.89,43.8 98.97,84.38 110.63,66.64 C115.04,59.94 116.01,34.94 116.02,34.88 L97.02,23.81 L75.84,18.16 L55.38,19.52 L39.38,22.65 L39.42,33.58 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.51,60.07 C109.85,59.92 123.13,56.07 122.69,69.59 C122.25,83.11 108.75,79.91 108.69,79.52 C108.63,79.13 109.51,60.07 109.51,60.07 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,74.52 C113.06,74.52 113.23,74.69 113.63,74.89 C114.183037,75.1461348 114.813721,75.1783857 115.39,74.98 C116.84,74.5 118.11,72.27 118.26,69.83 C118.328627,68.6700259 118.140843,67.5091775 117.71,66.43 C117.476238,65.5633011 116.834178,64.865247 115.99,64.56 C115.436863,64.3948164 114.844499,64.646886 114.58,65.16 C114.38,65.53 114.46,65.81 114.39,65.83 C114.32,65.85 114.1,65.59 114.23,65.04 C114.311651,64.7026711 114.510024,64.4051117 114.79,64.2 C115.174638,63.9330376 115.64776,63.8255098 116.11,63.9 C117.230747,64.1631471 118.135178,64.988109 118.5,66.08 C119.040318,67.2704441 119.280662,68.5751649 119.2,69.88 C119.03,72.61 117.55,75.12 115.57,75.62 C114.828549,75.8151701 114.038514,75.6564249 113.43,75.19 C113.06,74.85 113,74.54 113,74.52 Z",
    id: "Path",
    fill: "#B03F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.86,50.79 C52.44,51.53 49.86,50.79 46.72,50.74 C43.58,50.69 40.95,51.02 40.61,50.24 C40.27,49.46 42.94,47.56 46.86,47.74 C50.78,47.92 53.3,50.12 52.86,50.79 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,51.13 C82.84,51.87 80.25,51.18 77.12,51.07 C73.99,50.96 71.35,51.36 71,50.58 C70.65,49.8 73.33,47.9 77.25,48.08 C81.17,48.26 83.69,50.45 83.25,51.13 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,46.63 C104.73,46.63 4.53,33.38 1.21,29.81 C-1.42,26.97 12.69,23.81 37.97,25.81 C44.67,33.43 76.47,40.11 104.73,46.63 Z",
    id: "Path",
    fill: "#E7515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,49.77 L36.63,34.86 C36.63,34.86 34.97,13.86 59.4,7.27 C75.29,2.99 92.51,6.03 104.68,17.1 C112.13,23.89 118.25,34.28 116.46,49.77 Z",
    id: "Path",
    fill: "#FCD828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.79,88.45 C57.56,88.75 59.71,90.17 62.59,89.5 C65.47,88.83 66.8,86.63 66.46,86.5 C66.12,86.37 64.65,87.69 62.28,88.2 C59.91,88.71 58,88.09 57.79,88.45 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,49.77 C116.46,49.77 102.92,47.08 99.67,46.63 C97.08,46.28 89.36,44.71 89.36,44.71 C60.94,40.71 2.75,32.15 1.21,29.81 C-0.91,26.56 12.69,23.81 37.97,25.81 C44.67,33.43 88.2,43.25 116.46,49.77 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49,5.83 C81.33,6.05 83.33,7.38 85.69,10.29 C87.0444493,12.009518 88.186064,13.8864668 89.09,15.88 C90.139137,18.3518978 90.9170209,20.9303146 91.41,23.57 C92.205969,28.4255114 92.3572769,33.3648725 91.86,38.26 C91.52,42.04 91.1,44.37 91.31,44.42 C91.52,44.47 92.23,42.19 92.83,38.42 C93.6256827,33.429587 93.6020389,28.3428008 92.76,23.36 C92.2594983,20.5980367 91.412824,17.9101818 90.24,15.36 C89.2419418,13.2947208 87.9594791,11.379442 86.43,9.67 C85.4142858,8.5215147 84.2508203,7.51272954 82.97,6.67 C82.06,6 81.54,5.76 81.49,5.83 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.55,31.18 C48.77,31.25 49.55,28.84 51.45,25.33 C56.4899422,16.0801242 65.2662042,9.44601334 75.54,7.12 C79.44,6.21 81.96,6.12 81.9500297,5.92 C81.94,5.72 79.41,5.48 75.34,6.16 C64.5549692,8.05854059 55.3412535,15.0283667 50.58,24.89 C48.81,28.61 48.41,31.15 48.55,31.18 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,40.21 L110.77,38.11 L108.77,45.23 L116.77,47.73 C116.77,47.73 117.21,41.91 116.77,40.21 Z",
    id: "Path",
    fill: "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MAN_2",
    transform: "translate(423.000000, 335.000000)",
    fillRule: "nonzero"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.31,161 C61.5,172.72 83.94,157.19 83.94,157.19 C84.23,151.63 83.84,130.12 83.84,130.12 C83.84,130.12 103.65,127.04 103.9,107.23 C104.15,87.42 100.71,42 100.71,42 L100.71,42 C77.7752755,32.1397629 51.2997117,35.4688192 31.52,50.7 L28.58,52.96 C28.72,53.16 36.31,161 36.31,161 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,73.43 C30.67,73.28 17.39,69.43 17.82,82.95 C18.25,96.47 31.76,93.27 31.82,92.88 C31.88,92.49 31,73.43 31,73.43 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,14.35 C58.22,4.56 39.62,27.65 36.87,29.81 C34.12,31.97 17.46,41.67 15.03,43.87 C12.6,46.07 12.87,65.13 12.87,65.13 C12.87,65.13 4.46,68.82 1.28,74.84 C-5.72,87.99 34.09,130.29 34.09,130.29 C49.09,134.7 66.19,120.15 66.19,120.15 C66.19,120.15 71.12,111.52 69.91,107.07 C69.1712667,103.818387 68.9485454,100.470819 69.25,97.15 C69.25,97.15 59.66,98.3 58.58,89.94 C57.5,81.58 64.78,74.57 69.1,74.84 C73.42,75.11 75.16,82.84 77.59,81.84 C80.02,80.84 78.4,61.6 78.4,61.6 C78.4,61.6 95.7,58.43 105.76,39.22 C115.82,20.01 117.62,-20.25 73.87,14.35 Z",
    id: "Path",
    fill: "#121217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15,91.22 L68.64,91.22 C68.1640098,91.1931181 67.6966584,91.0813602 67.26,90.89 C67.12,90.83 66.96,90.77 66.81,90.69 L66.37,90.36 C66.0348894,90.1104817 65.755592,89.7937175 65.55,89.43 C65.0688225,88.6198009 64.8553688,87.6785051 64.94,86.74 C65.08466,85.1745408 65.6591388,83.6795115 66.6,82.42 C66.9587806,81.9015668 67.3710442,81.4222685 67.83,80.99 L67.32,82.76 C66.9239472,84.0875048 66.6593416,85.4507257 66.53,86.83 C66.3370275,88.0818817 66.7705366,89.3487748 67.69,90.22 C67.9877496,90.5170242 68.3240985,90.7726493 68.69,90.98 L69.15,91.22 Z",
    id: "Path",
    fill: "#B03F33"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ARMS-2",
    transform: "translate(10.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.72,6 L366.06,23 C365.700061,26.6088699 366.289538,30.2491496 367.77,33.56 L372.49,44.12 C372.811409,44.8343225 372.939023,45.6206951 372.86,46.4 L367.51,99.08 C367.47724,99.4406341 367.30097,99.7729877 367.020789,100.002398 C366.740608,100.231807 366.380009,100.339038 366.02,100.3 L336.38,97.3 C336.02117,97.2647372 335.691356,97.087399 335.464062,96.8075071 C335.236767,96.5276151 335.13088,96.16843 335.17,95.81 L340.48,43.43 C340.561869,42.6088358 340.869962,41.8264872 341.37,41.17 L348.17,31.51 C350.23,28.6 350.93,25.98 351.85,21.66 L355.57,4.85 L366.72,6 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FAFBFB",
    points: "339.64 51.69 359.62 53.71 356.06 88.8 336.08 86.77"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E32D27",
    transform: "translate(361.349571, 3.188573) rotate(-174.210000) translate(-361.349571, -3.188573) ",
    x: 353.884571,
    y: 0.818573009,
    width: 14.93,
    height: 4.74,
    rx: 0.83
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAFBFB",
    points: "356.75 22.25 366 23.19 366.46 12.75 357.81 11.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,69.23 C337.559597,72.1676888 339.058657,74.9970091 341.657997,76.3983258 C344.257337,77.7996425 347.444904,77.4969053 349.733972,75.6313152 C352.02304,73.765725 352.962676,70.7047911 352.114622,67.8761762 C351.266568,65.0475614 348.797884,63.0084846 345.86,62.71 C341.852534,62.3083782 338.275186,65.2239167 337.86,69.23 L337.86,69.23 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,53.18 C339.49,53.31 341.34,53.62 344.6,54.06 C347.86,54.5 352.49,55.06 358.04,55.67 L357.5,55.01 C356.99,59.79 356.41,65.23 355.8,71.01 C355.19,76.79 354.72,82.22 354.25,87.01 L354.91,86.48 C349.36,85.97 344.7,85.58 341.42,85.35 C338.14,85.12 336.26,85.06 336.239842,85.19 C336.22,85.32 338.1,85.6299962 341.35,86.06 C344.6,86.49 349.25,87.06 354.79,87.68 L355.39,87.74 L355.45,87.14 C355.96,82.35 356.54,76.91 357.15,71.14 C357.76,65.37 358.23,59.93 358.7,55.14 L358.76,54.53 L358.16,54.53 C352.6,54.02 347.94,53.6299962 344.67,53.41 C341.4,53.19 339.5,53.05 339.49,53.18 Z",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8A89A",
    points: "339.63 51.79 339.63 51.78 339.63 51.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,54.2 C369.19,52.82 364,54.2 364,54.2 C365.15,53.2 363.56,50.8 361.74,51 C360.89,51.1 355.74,52.84 350.51,54.67 C345.44,56.44 340.32,58.29 338.99,58.77 L338.99,58.77 L339.83,49.92 C336.044292,52.4146696 332.569737,55.3520953 329.48,58.67 C323.62,64.69 275,140.5 275,140.5 L192.33,155.33 L173.56,220.92 C173.56,220.92 298.72,188.66 307.82,180.57 C312.77,176.18 321.92,151.69 329.24,130.25 C335.39,112.25 340.24,96.37 340.24,96.37 C343.113742,94.5452552 345.820902,92.4705463 348.33,90.17 C354.5,84.87 361.85,77.94 364.1,75.81 C367.61,72.51 366.43,66.91 366.43,66.91 C369.43,64.55 367.68,59.43 367.68,59.43 C368.85,58.55 370,55.58 369.6,54.2 Z",
    id: "Path",
    fill: "#F8A89A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.73,210.3 C27.73,210.3 -0.18,269 1,282.3 C2.18,295.6 74.25,349 74.25,349 L76.53,290 L60.9,275 L74.25,237 L27.73,210.3 Z",
    id: "Path",
    fill: "#F8A89A"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SHOES-2",
    transform: "translate(0.000000, 874.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.76,54.46 C268.792521,52.1702047 268.499595,49.8873998 267.89,47.68 C266.27,42.45 213.48,21.56 213.48,21.56 L174.18,26.22 C174.18,26.22 172.18,43.93 171.58,52.86 C175.58,55.35 185.98,61.01 196.7,61.01 C209.32,61 260.46,55.38 268.76,54.46 Z",
    id: "Path",
    fill: "#042D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,57.64 C172.02,60.64 183.01,65.32 194.07,66.64 C205.13,67.96 268.39,60.07 268.39,60.07 C268.648574,58.2013206 268.772227,56.3164447 268.760825,54.43 C260.46,55.35 209.32,60.98 196.7,60.98 C185.98,60.98 175.62,55.32 171.58,52.83 C171.418933,54.4281305 171.385494,56.0365561 171.48,57.64 L171.48,57.64 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,53.72 C78.99,51.72 57.65,25.1 57.65,24.6 C57.65,24.1 59.27,15.39 59.27,15.39 L17.27,0.93 L1.69,32.79 L78.53,62 C79.86,58.73 81.19,54.84 80.4,53.72 Z",
    id: "Path",
    fill: "#042D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78,39.51 L74.78,66.25 C75.6578042,66.5763063 76.6387528,66.1708476 77.03,65.32 C77.43,64.45 77.96,63.26 78.49,61.98 L1.68,32.79 L0.79,34.62 C0.346981817,35.5253719 0.310917451,36.5766645 0.690849992,37.5102676 C1.07078253,38.4438707 1.83068031,39.1712441 2.78,39.51 L2.78,39.51 Z",
    id: "Path",
    fill: "#000000"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "PANTS-2",
    transform: "translate(10.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213,5.29 C213,5.29 249.81,177.48 245,223.57 C240.19,269.66 220.33,497.57 220.33,497.57 L152.33,502.57 C152.33,502.57 173.77,247 172.96,223.57 C172.15,200.14 154.76,132.24 154.76,132.24 C154.76,132.24 148.29,209.32 140.2,241.16 C132.11,273 61.46,495.89 61.46,495.89 L0.51,475.22 C0.51,475.22 64.15,263.51 70.63,207.65 C77.11,151.79 76.55,0.46 76.55,0.46 L213,5.29 Z",
    id: "Path",
    fill: "#094166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.63,267.45 C136.28,255.25 138.95,246 140.18,241.16 C148.27,209.32 154.74,132.24 154.74,132.24 L132.63,74.14 C132.63,74.14 144.49,214.41 132.63,267.45 Z",
    id: "Path",
    fill: "#042D3F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SHIRT-2",
    transform: "translate(20.000000, 151.000000)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2,16.4 L163.58,3.12 C163.58,3.12 119.11,-2.27 107.38,3.12 L100.38,22.54 L168.2,16.4 Z",
    id: "Path",
    fill: "#2B2D6E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.66,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(100.000000, 6.000000)",
    fill: "#0F1235"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2,10.4 L66.51,5.52 C53.2,-0.08 19.27,0.52 5.89,1.25 L0.34,16.54 L68.2,10.4 Z",
    id: "Path"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M254.76,18.76 L251,86.35 L203.11,98.87 L212.5,269.18 L58.5,264.5 L58.5,143.5 L0.29,110.74 C0.29,110.74 39.69,31.74 61.45,24.31 C83.21,16.88 115.96,11.31 139.52,12.31 C163.08,13.31 254.76,18.76 254.76,18.76 Z",
    id: "Path",
    fill: "#2B2D6E"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "PLANT",
    transform: "translate(134.000000, 874.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.38,0.21 C63.26,2.65 56.5,21.21 57.82,36.47 C59.14,51.73 65.42,66.64 63.74,81.85 C61.61,101.18 47,117.51 45.3,136.85 C43.3,159.69 59.45,179.95 64.3,202.37 C66.65,213.27 66.3,224.81 70.38,235.2 C77.23,252.72 97.31,263.97 115.82,260.66 C134.33,257.35 149.28,239.84 149.64,221.04 C149.98,203.5 139.15,186.98 140.47,169.49 C141.47,156.56 149.02,144.31 147.4,131.49 C145.47,116.18 131.28,105.31 126.28,90.72 C121.28,76.13 126.08,60.04 124.35,44.72 C121.25,17.21 106,-1.96 78.41,0.24",
    id: "Path",
    fill: "#E32D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19,133.41 C-1.38,158.9 9.89,188.89 23,210.9 C36.274137,233.05342 56.2604253,250.402191 80.06,260.43 C82.73,261.54 86.06,262.43 88.29,260.66 C90.13,259.17 90.35,256.49 90.37,254.12 C90.7362303,198.54753 54.4172708,149.387835 1.19,133.41",
    id: "Path",
    fill: "#E7515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19,133.41 C-1.38,158.9 9.89,188.89 23,210.9 C36.274137,233.05342 56.2604253,250.402191 80.06,260.43 C82.73,261.54 86.06,262.43 88.29,260.66 C90.13,259.17 90.35,256.49 90.37,254.12 C90.7362303,198.54753 54.4172708,149.387835 1.19,133.41",
    id: "Path",
    fill: "#FCD828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,313.72 C111.926288,313.280224 111.680908,312.802908 111.5,312.3 L109.68,308.13 C108.15,304.49 105.86,299.25 102.94,292.82 C95.3401343,276.069618 86.8959634,259.715295 77.64,243.82 C68.3315233,227.951923 58.2252412,212.565543 47.36,197.72 C43.19,192.02 39.75,187.46 37.36,184.33 L34.62,180.7 C34.275489,180.290622 33.9770294,179.84461 33.73,179.37 C34.1466005,179.705445 34.5195078,180.09179 34.84,180.52 L37.84,183.98 C40.4,186.98 43.97,191.48 48.26,197.11 C59.3960467,211.821279 69.6474716,227.18172 78.96,243.11 C88.2613409,259.037702 96.6093458,275.503307 103.96,292.42 C106.76,298.92 108.96,304.23 110.28,307.94 C110.92,309.67 111.44,311.09 111.85,312.22 C112.032266,312.704246 112.159728,313.207382 112.23,313.72 L112.23,313.72 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.82,70.73 C95.9731407,71.5384678 96.0634109,72.3575857 96.09,73.18 C96.2166667,74.9133333 96.3866667,77.2466667 96.6,80.18 C97,86.41 97.6,95.18 98.26,106.01 C99.64,127.81 101.57,157.94 103.91,191.2 C106.25,224.46 108.56,254.57 110.25,276.36 C111.08,287.15 111.75,295.94 112.25,302.17 C112.45,305.123333 112.61,307.456667 112.73,309.17 C112.822634,309.986617 112.842712,310.809838 112.79,311.63 C112.615929,310.82594 112.49897,310.01057 112.44,309.19 C112.25,307.47 112,305.13 111.69,302.19 L109.25,276.42 C107.3,254.65 104.83,224.55 102.49,191.27 C100.15,157.99 98.38,127.86 97.26,106.03 C96.76,95.22 96.35,86.42 96.06,80.18 C95.96,77.18 95.88,74.88 95.82,73.18 C95.753194,72.3646996 95.753194,71.5453004 95.82,70.73 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.37,277.37 L136.21,277.37 L136.21,324.24 C136.21,332.367966 132.980494,340.162886 127.232217,345.909288 C121.483939,351.65569 113.687966,354.882653 105.56,354.880002 L105.56,354.880002 C89.2737505,354.882085 75.8317182,342.142904 74.96,325.88 L72.37,277.37 Z",
    id: "Path",
    fill: "#752A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,299.7 C136.41,299.81 135.67,299.23 134.15,298.7 C131.969315,298.057572 129.662444,297.971623 127.44,298.45 C124.59,298.92 121.44,300.38 117.78,301.83 C115.837223,302.626163 113.806097,303.186821 111.73,303.5 C109.466517,303.755121 107.176604,303.640288 104.95,303.16 C100.41,302.16 96.47,300.4 92.8,299.22 C89.5937131,298.08802 86.1950427,297.60201 82.8,297.79 C80.5372516,297.899867 78.3405409,298.588491 76.42,299.79 C75.09,300.69 74.5,301.41 74.42,301.32 C74.34,301.23 74.8,300.43 76.09,299.32 C78.0047673,297.838676 80.3000959,296.930253 82.71,296.7 C86.2467355,296.349574 89.8176219,296.748233 93.19,297.87 C96.97,299.01 100.92,300.75 105.19,301.65 C107.256724,302.109832 109.384348,302.231411 111.49,302.01 C113.457372,301.724598 115.386247,301.218059 117.24,300.5 C120.84,299.17 124.18,297.73 127.24,297.37 C129.623811,296.956296 132.075773,297.216038 134.32,298.12 C135.182646,298.422429 135.937293,298.971895 136.49,299.7 L136.49,299.7 Z",
    id: "Path",
    fill: "#471117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,305.17 C136.41,305.28 135.67,304.71 134.15,304.17 C131.970155,303.52245 129.661988,303.436453 127.44,303.92 C124.59,304.39 121.44,305.85 117.78,307.3 C115.838367,308.097375 113.806684,308.654829 111.73,308.96 C109.466847,309.225377 107.175249,309.110459 104.95,308.62 C100.41,307.62 96.47,305.86 92.8,304.69 C89.5937131,303.55802 86.1950427,303.07201 82.8,303.26 C80.5381143,303.374699 78.342591,304.062951 76.42,305.26 C75.09,306.17 74.5,306.89 74.42,306.8 C74.34,306.71 74.8,305.91 76.09,304.8 C78.0022873,303.314326 80.2989273,302.405384 82.71,302.18 C86.2467355,301.829574 89.8176219,302.228233 93.19,303.35 C96.97,304.49 100.92,306.23 105.19,307.13 C107.257244,307.586666 109.384893,307.704869 111.49,307.48 C113.458219,307.204016 115.387781,306.700652 117.24,305.98 C120.84,304.64 124.18,303.21 127.24,302.85 C129.623647,302.431448 132.076948,302.691331 134.32,303.6 C135.180296,303.901791 135.934249,304.447278 136.49,305.17 Z",
    id: "Path",
    fill: "#471117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,308.28 C83.79,308.49 83.29,308.75 83.11,309.49 C82.93,310.23 83.27,311.13 84.31,310.96 C85.35,310.79 85.44,309.86 85,309.19 C84.56,308.52 84,308.46 84,308.25 C84,308.04 84.79,307.64 85.79,308.47 C86.7375298,309.299033 86.8754781,310.722602 86.1047551,311.718139 C85.334032,312.713676 83.9212968,312.936739 82.8813353,312.2271 C81.8413738,311.51746 81.533998,310.120643 82.18,309.04 C82.85,307.94 83.83,308.09 83.79,308.28 Z",
    id: "Path",
    fill: "#471117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,296.11 C106.69,296.04 107.16,295.11 108.45,295.35 C109.247078,295.513629 109.848417,296.17147 109.94,296.98 C110.048893,297.988611 109.466339,298.944492 108.52,299.31 C107.565226,299.616757 106.52211,299.26364 105.95,298.44 C105.498792,297.79538 105.467482,296.946094 105.87,296.27 C106.55,295.21 107.46,295.35 107.44,295.53 C107.42,295.71 106.99,296.03 106.84,296.7 C106.741578,297.019038 106.821728,297.366353 107.05,297.61 C107.300533,297.889879 107.686778,298.005752 108.05,297.91 C108.367829,297.75076 108.577227,297.43476 108.6,297.08 C108.609595,296.773848 108.436818,296.491122 108.16,296.36 C107.54,296 107,296.26 106.88,296.11 Z",
    id: "Path",
    fill: "#471117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23,307.92 C129.16,307.75 130.09,307.38 131.1,308.32 C131.70867,308.913929 131.922545,309.804425 131.65,310.61 C131.3113,311.641452 130.34562,312.336418 129.26,312.330044 C128.164405,312.258244 127.247689,311.471905 127.01,310.4 C126.819847,309.543444 127.193115,308.660444 127.94,308.2 C129.18,307.49 130.01,308.2 129.86,308.34 C129.71,308.48 129.13,308.44 128.59,309.03 C128.328056,309.291399 128.231884,309.676086 128.34,310.03 C128.495476,310.46076 128.884348,310.76408 129.34,310.81 C129.797387,310.77891 130.202517,310.503727 130.4,310.09 C130.569617,309.724673 130.539395,309.297786 130.32,308.96 C129.88,308.28 129.23,308.13 129.23,307.92 Z",
    id: "Path",
    fill: "#471117"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogin);
export default __webpack_public_path__ + "static/media/illustration-login.19aa7c3c5e872695ece6713e9729f0f8.svg";
export { ForwardRef as ReactComponent };